class EngravingInput extends HTMLElement {
  constructor() {
    super();

    // Dynamically find the input(s) inside this custom element
    this.input = this.querySelector('textarea, input, select'); // Support for multiple types

    // Find the Add to Cart button (Shopify standard)
    this.addToCartButton = document.querySelector(
      '[type="submit"][name="add"]'
    );

    // Check if this element has the data-required attribute
    this.isRequired = this.hasAttribute('data-required');
  }

  connectedCallback() {
    if (this.isRequired && this.input && this.addToCartButton) {
      // Disable the Add to Cart button initially
      this.addToCartButton.disabled = true;

      // Add event listeners based on input type
      this.addListeners();
    }
  }

  addListeners() {
    const inputType = this.input.type;

    if (inputType === 'checkbox' || inputType === 'radio') {
      // For checkboxes and radio buttons
      this.input.addEventListener('change', this.handleInputChange.bind(this));
    } else if (
      inputType === 'textarea' ||
      inputType === 'text' ||
      inputType === 'email' ||
      inputType === 'password'
    ) {
      // For text-based inputs
      this.input.addEventListener('input', this.handleInputChange.bind(this));
    } else if (inputType === 'select-one' || inputType === 'select-multiple') {
      // For select dropdowns
      this.input.addEventListener('change', this.handleInputChange.bind(this));
    }
  }

  handleInputChange() {
    if (this.isInputValid()) {
      // Enable the Add to Cart button
      this.addToCartButton.disabled = false;
    } else {
      // Disable the Add to Cart button
      this.addToCartButton.disabled = true;
    }
  }

  isInputValid() {
    const inputType = this.input.type;

    if (inputType === 'checkbox' || inputType === 'radio') {
      return this.input.checked; // Check if checked
    } else if (
      inputType === 'textarea' ||
      inputType === 'text' ||
      inputType === 'email' ||
      inputType === 'password'
    ) {
      return this.input.value.trim().length > 0; // Validate non-empty value
    } else if (inputType === 'select-one' || inputType === 'select-multiple') {
      return this.input.value !== ''; // Validate selection
    }

    // Default to invalid for unsupported types
    return false;
  }
}

// Define the custom element
customElements.define('engraving-input', EngravingInput);
